import React, { useEffect, useState } from "react";
// NAVIGATION
import { useLocation } from "react-router-dom";
// REDUX
import { useSelector } from "react-redux";
import { usePutBankMutation } from "../../../redux/banks/bankAPI";
// CUSTOM HOOKS
import useGetOneBank from "../../../customHooks/GET_requests/useGetOneBank";
// INTERFACES
import { RootState } from "../../../app/store";
import { BankInterface } from "../../../interfaces/Bank.interface";
// COMPONENTS
import BankDetailsCard from "./BanksDetailCard";
import BanksDebounceOverrides from "./BanksDebounceOverrides";
import GlobalAlert2 from "../../home/GlobalAlert2";
// CONSTANTS
import { BLANK_BANK } from "../../../constants/bank";
// FLATBUFFER TYPES
// import { MessageContent } from "../../../flatbuffers/generated/ln2/message-content";
// import { LiftType } from "../../../flatbuffers/generated/archive/lift-type";

export default function BanksConfiguration() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const location = useLocation();
  const idBank = new URLSearchParams(location.search).get("idBank");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [bank, setBank] = useState<BankInterface>({ ...BLANK_BANK });
  // const [bankOffsets, setBankOffsets] = useState<Partial<Record<MessageContent, number[]>>>({});
  // const [bankIntraFlags, setBankIntraFlags] = useState<Partial<Record<MessageContent, boolean[]>>>(
  //  {},
  // );

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [, { isSuccess: isSuccessPutBank, isError: isErrorPutBank, error: errorPutBank }] =
    usePutBankMutation();

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { bank: bankHook, isLoadingGetOneBank } = useGetOneBank({
    id: idBank ?? "",
  });

  // ************************************************ */
  // FUNCTIONS ************************************** */
  /* const onClickSave = async () => {
    const token = await GETJwtToken();
    const { dataBlocks: _dataBlocks, ...copy } = bank as any;
    const body: any = {
      ...copy,
      lifts: [],
    };
    if (isLn1Based) {
      body.offsetMapping = bankOffsets;
      body.intraContentFlags = bankIntraFlags;
    }
    triggerPutBank({ token, body, id: formatUuidT(bank.id) });
    resetPutBank();
  }; */

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (bankHook && bankHook.id) {
      setBank(bankHook);
      if ((bankHook as any).offsetMapping && typeof (bankHook as any).offsetMapping === "object") {
        // setBankOffsets(
        //   normalizeOffsetMap<number[]>((bankHook as any).offsetMapping as Record<string, number[]>),
        // );
      }
      if (
        (bankHook as any).intraContentFlags &&
        typeof (bankHook as any).intraContentFlags === "object"
      ) {
        // setBankIntraFlags(
        //   normalizeOffsetMap<boolean[]>(
        //     (bankHook as any).intraContentFlags as Record<string, boolean[]>,
        //   ),
        // );
      }
    }
  }, [bankHook]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__flexWrap">
      <div
        className={`layout__contentPage__${theme}`}
        style={{
          minWidth: "500px",
          width: "100%",
          overflowX: "auto",
          margin: "5px",
        }}
      >
        <BankDetailsCard bank={bank} isLoadingGetOneBank={isLoadingGetOneBank} />

        <div style={{ marginTop: "10px" }}>
          <BanksDebounceOverrides bank={bank} isLoading={isLoadingGetOneBank} />
        </div>
      </div>

      <GlobalAlert2
        isError={isErrorPutBank}
        isSuccess={isSuccessPutBank}
        requestType="PUT"
        error={errorPutBank}
        name="Bank"
      />
    </div>
  );
}
